import React, { useState } from 'react';
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UploadOutlined,
  UserOutlined,
  FileTextOutlined,
  ProductOutlined,
  GiftOutlined,
  HeartOutlined,
  GatewayOutlined,
  AuditOutlined,
  SettingOutlined,
  TagOutlined,
  GroupOutlined
} from '@ant-design/icons';
import { Avatar, Button, Flex, Layout, Menu, theme, Dropdown, Space } from 'antd';
import PageRoutes from "./PageRoutes"
import { BrowserRouter, useLocation, useNavigate } from "react-router-dom";
import AppMenu from "./Menu"
import { useAuth } from "contexts/auth"
const { Header, Sider, Content } = Layout;

const App = () => {
  const [collapsed, setCollapsed] = useState(false);
  const { user, logout } = useAuth()



  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const accountMenuClick = (e) => {
    if (e.key == "logout") {
      logout();
      return;
    }

  }

  return (
    <BrowserRouter basename="/">
      <Layout>
        <Sider trigger={null} collapsible collapsed={collapsed}>
          <div className="demo-logo-vertical" />
          <AppMenu></AppMenu>

        </Sider>
        <Layout>
          <Header style={{ padding: 0, background: colorBgContainer }}>

            <Flex>

              <Space>
                <Button
                  type="text"
                  icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                  onClick={() => setCollapsed(!collapsed)}
                  style={{
                    fontSize: '16px',
                    width: 64,
                    height: 64,
                  }}
                />
              
              </Space>

              <div style={{ flexGrow: 1, justifyContent: "center", flexDirection: "row", display: "flex", paddingRight: 16 }}>
                <Flex justify='flex-end' style={{ width: "100%" }}>
                  <div style={{ justifyContent: "center", flexDirection: "column", display: "flex", paddingRight: 16 }}>
                    <Dropdown menu={{
                      items: [
                        {
                          key: 'logout',
                          label: 'Đăng xuất',

                        },
                      ],
                      onClick: accountMenuClick
                    }}>
                      <Avatar >{user.first_name}</Avatar>
                    </Dropdown>

                  </div>

                </Flex>
              </div>
            </Flex>
          </Header>
          <Content
            style={{
              margin: '24px 16px',
              padding: 24,
              minHeight: '100vh',
              background: colorBgContainer,
              borderRadius: borderRadiusLG,
            }}
          >
            <PageRoutes></PageRoutes>
          </Content>
        </Layout>
      </Layout>
    </BrowserRouter>
  );
};

export default App;